import dynamic from 'next/dynamic'
import React from 'react'

import type CustomSection from '@src/quince-site-common/src/domains/CustomSection'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import FeatureSectionEightLegacy from './feature-section-eight-legacy'

// Dynamic-import the DS twin to keep its web-ui/carousel + Panda bundle off the legacy path.
const FeatureSectionEightDS = dynamic(
  () => import(/* webpackChunkName: "feature-section-eight-ds" */ './feature-section-eight-ds'),
)

interface FeatureSectionEightProps {
  section: CustomSection
}

// Router: DS branch when the Design System gate is active, else the legacy Swiper atom.
function FeatureSectionEight({ section }: FeatureSectionEightProps) {
  if (shouldUseDesignSystem()) {
    return <FeatureSectionEightDS section={section} />
  }
  return <FeatureSectionEightLegacy section={section} />
}

export default FeatureSectionEight
